import React from 'react';
import { Wrench } from 'lucide-react';

const DefaultToolComponent = ({ toolName }) => {
  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 rounded-full bg-blue-500/20 flex items-center justify-center mx-auto mb-4">
        <Wrench className="w-8 h-8 text-blue-500" />
      </div>
      <h3 className="font-semibold mb-2">Coming Soon</h3>
      <p className="text-sm text-muted-foreground mb-4">
        {toolName || 'This tool'} is currently under development.
      </p>
      <p className="text-xs text-muted-foreground">
        Check back soon for the full interactive interface!
      </p>
    </div>
  );
};

export default DefaultToolComponent;
